/**
 * 中文语言包
 */
export default {
  common: {
    confirm: '确定',
    cancel: '取消',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    search: '搜索',
    reset: '重置',
    submit: '提交',
    back: '返回',
    close: '关闭',
    refresh: '刷新',
    loading: '加载中...',
    success: '操作成功',
    error: '操作失败',
    warning: '警告',
    info: '提示',
    yes: '是',
    no: '否',
    enable: '启用',
    disable: '禁用',
    enabled: '已启用',
    disabled: '已禁用',
    online: '在线',
    offline: '离线',
    normal: '正常',
    total: '共',
    items: '条',
    all: '全部',
    export: '导出数据',
    import: '导入数据',
    download: '下载',
    upload: '上传',
    action: '操作',
    view: '查看',
    copy: '复制',
    clear: '清空',
    filter: '筛选',
    sort: '排序',
    pleaseSelect: '请选择',
    confirmSave: '确定保存？',
    setAsDefault: '设为默认',
    user: '用户',
    password: '密码',
    personalCenter: '个人中心',
    personalSettings: '个人设置',
    logout: '退出登录',
    // 通用字段
    avatar: '头像',
    name: '名称',
    description: '描述',
    status: '状态',
    createTime: '创建时间',
    updateTime: '更新时间',
    isDefault: '默认',
    default: '默认',
    platform: '平台',
    basicInfo: '基本信息',
    // 通用操作
    clickToUpload: '点击上传',
    changeAvatar: '更换头像',
    uploadAvatar: '上传头像',
    removeAvatar: '移除头像',
    avatarTip: '支持JPG、PNG、GIF格式，不超过2MB',
    avatarUploadFailed: '头像上传失败: ',
    avatarUploadSuccess: '头像上传成功',
    clickToChangeAvatar: '点击头像更换',
    avatarFormatTip: '支持 JPG、PNG 格式，大小不超过 2MB',
    // 文件上传验证
    onlyImageFiles: '只能上传图片文件!',
    imageSizeLimit: '图片大小不能超过2MB!',
    // 通用提示
    setDefaultSuccess: '已将"{name}"设为默认',
    setDefaultFailed: '设置默认失败',
    operationFailed: '操作失败',
    operationSuccess: '操作成功',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    confirmDelete: '确定删除？',
    system: '系统',
    noData: '暂无数据',
    loadFailed: '加载失败',
    addSuccess: '添加成功',
    updateSuccess: '更新成功',
    // 通用占位符
    enterUsername: '请输入用户名',
    enterEmail: '请输入邮箱',
    enterPhone: '请输入手机号',
    enterPassword: '请输入密码',
    enterConfirmPassword: '请再次输入密码',
    enterVerificationCode: '请输入验证码',
    // 平台配置通用
    platformConfig: '平台配置',
    getPlatformConfigFailed: '获取平台配置失败',
    updatePlatformConfigSuccess: '更新平台配置成功',
    addPlatformConfigSuccess: '添加平台配置成功',
    updatePlatformConfigFailed: '更新平台配置失败',
    addPlatformConfigFailed: '添加平台配置失败',
  },

  menu: {
    dashboard: 'Dashboard',
    user: '用户管理',
    device: '设备管理',
    message: '对话管理',
    role: '角色配置',
    template: '模板管理',
    config: '配置管理',
    // New Menu Items
    robotManagement: '机器人管理',
    deviceMarket: '设备市场',
    magicToolMarket: '魔法工具市场',
    creativeWorkshop: '创意工坊',
    systemSettings: '系统设置',
    knowledgeManagement: '知识管理',
    workflowManagement: '流程管理',
    modelManagement: '模型管理',
    roleManagement: '角色管理',
    dataManagement: '数据管理',
    deviceManagement: '智能套件', // 原 IoT管理
    monitorOps: '监控运维',

    agent: '智能体管理',
    sttConfig: '语音识别配置',
    ttsConfig: '语音合成配置',
    knowledgeBases: '知识库管理',
    firmwareManagement: '固件管理',
    multimodalAgent: '角色管理',
    processingStrategy: '处理策略',
    perceptionData: '感知数据',
    setting: '设置',
    account: '个人中心',
    personalConfig: '个人设置',

    // 菜单管理相关
    menu: '菜单管理',
    menuList: '菜单列表',
    addMenu: '新增菜单',
    editMenu: '编辑菜单',
    addChild: '新增子菜单',
    parentMenu: '上级菜单',
    rootMenu: '根菜单',
    selectParent: '请选择上级菜单',
    name: '菜单名称',
    nameRequired: '请输入菜单名称',
    namePlaceholder: '请输入菜单名称',
    code: '菜单编码',
    codeRequired: '请输入菜单编码',
    codePlaceholder: '请输入菜单编码',
    type: '菜单类型',
    typeRequired: '请选择菜单类型',
    typePlaceholder: '请选择菜单类型',
    typeMenu: '菜单',
    typeButton: '按钮',
    typeLink: '外链',
    routePath: '路由路径',
    routePathPlaceholder: '请输入路由路径',
    componentPath: '组件路径',
    componentPathPlaceholder: '请输入组件路径',
    icon: '菜单图标',
    iconPlaceholder: '请选择菜单图标',
    permissionCode: '权限编码',
    permissionCodePlaceholder: '请输入权限编码',
    visible: '是否可见',
    isCached: '是否缓存',
    confirmDelete: '确定删除菜单【{name}】吗？删除后子菜单也会被删除！',
    permission: '权限管理',
  },

  auth: {
    login: '登录',
    register: '注册',
    logout: '退出登录',
    forgetPassword: '忘记密码',
    verificationCode: '验证码',
    rememberMe: '记住我',
    loginSuccess: '登录成功',
    loginFailed: '登录失败',
    logoutSuccess: '退出成功',
    registerSuccess: '注册成功',
    passwordReset: '密码重置成功',
    loginAgreement: '登录即表示您同意',
    otherLoginMethods: '其他方式登录',
    noAccount: '没有账号？',
    // 注册相关
    name: '姓名',
    enterName: '请输入姓名',
    enterPhoneOptional: '请输入电话号码（可选）',
    emailVerificationCode: '邮箱验证码',
    agreeTerms: '我已阅读并同意',
    agreeTermsRequired: '请同意用户协议',
    haveAccount: '已有账号？',
    loginNow: '立即登录',
    // 忘记密码相关
    newPassword: '新密码',
    enterNewPassword: '请输入新密码',
    confirmNewPassword: '确认新密码',
    enterConfirmNewPassword: '请再次输入新密码',
    verifyEmail: '验证邮箱',
    resetPassword: '重置密码',
    rememberPassword: '想起密码了？',
    backToLogin: '返回登录',
    // 验证码相关
    sending: '发送中...',
    resendAfter: '{seconds}s后重发',
    sendVerificationCode: '发送验证码',
    enterEmailFirst: '请先输入邮箱地址！',
    enterValidEmail: '请输入正确的邮箱格式！',
    verificationCodeSent: '验证码已发送到您的邮箱！',
    sendVerificationCodeFailed: '发送验证码失败！',
    sendVerificationCodeRetry: '发送验证码失败，请稍后重试',
    verificationSuccess: '验证成功！',
    verificationCodeError: '验证码错误',
  },

  user: {
    username: '用户名',
    email: '邮箱',
    phone: '电话',
    role: '角色',
    admin: '管理员',
    normalUser: '普通用户',
    lastLoginTime: '最后登录时间',
    lastLoginIp: '最后登录IP',
    deviceCount: '设备数量',
    onlineDeviceCount: '在线设备数',
    messageCount: '消息数',
    accountType: '账户类型',
    normal: '正常',
    disabled: '禁用',
    assignRoles: '分配角色',
    assignRolesFor: '为用户 {name} 分配角色',
    confirmToggleStatus: '确定要{action}用户【{name}】吗？',
    cancelAccount: '注销账号',
    cancelSuccess: '账号注销成功',
    cancelFailed: '账号注销失败',
    confirmDeleteUser: '确定要注销账号【{name}】吗？注销后用户无法登录，原手机号、邮箱和微信身份可重新注册；历史资产与审计记录仍会保留。',
  },

  // 权限管理相关
  permission: {
    name: '权限名称',
    code: '权限编码',
    resourceType: '资源类型',
    resourceUrl: '资源URL',
    httpMethod: 'HTTP方法',
    confirmDelete: '确定要删除权限【{name}】吗？',
  },

  // 角色管理相关
  role: {
    name: '角色名称',
    code: '角色编码',
    description: '角色描述',
    isSystem: '系统角色',
    configPermissions: '配置权限',
    configMenus: '配置菜单',
    confirmDelete: '确定删除角色【{name}】吗？',
    cannotDeleteSystem: '系统内置角色不能删除',
    permissionConfigTitle: '权限配置 - {name}',
    menuConfigTitle: '菜单配置 - {name}',
    expandAll: '展开全部',
    collapseAll: '折叠全部',
    selectAll: '全选',
    deselectAll: '取消全选',
    selectedCount: '已选 {count} 项',
    searchPermission: '搜索权限名称',
    searchMenu: '搜索菜单名称',
    noData: '暂无数据',
  },

  device: {
    deviceId: '设备ID',
    deviceName: '设备名称',
    deviceType: '设备类型',
    onlineStatus: '在线',
    offlineStatus: '离线',
    lastOnlineTime: '最后在线时间',
    owner: '所有者',
    wifiName: 'WIFI名称',
    location: '地理位置',
    productType: '产品类型',
    addDevice: '添加设备',
    enterDeviceCode: '请输入设备码',
    confirmDelete: '确定要删除此设备吗？',
    configureDefaultRole: '请先配置默认角色',
    version: '版本号',
    activeTime: '活跃时间',
    // 角色相关
    roleName: '角色名称',
    roleDesc: '角色描述',
    voiceName: '音色',
    modelName: '对话模型',
    sttName: '语音识别',
    totalDevice: '设备数量',
    createRole: '创建角色',
    updateRole: '更新角色',
    roleList: '角色列表',
    enterRoleName: '请输入角色名称',
    setAsDefaultRole: '设为默认角色',
    defaultRoleTip: '设为默认后将优先使用此角色',
    conversationModelSettings: '对话模型设置',
    modelType: '模型类型',
    llmModel: 'LLM模型',
    agent: '智能体',
    model: '模型',
    selectModel: '请选择模型',
    conversationModelAdvanced: '对话模型高级设置',
    temperature: '温度',
    temperatureTip: '控制回答的创造性：\n- 低值(0.2)：更精确保守\n- 高值(0.8)：更有创意多样',
    topP: '核心采样',
    topPTip: '控制词汇选择范围：\n- 低值(0.5)：更聚焦\n- 高值(0.9)：考虑更多可能性',
    speechRecognitionSettings: '语音识别设置',
    speechRecognition: '语音识别',
    selectSpeechRecognition: '请选择语音识别配置',
    speechRecognitionAdvanced: '语音识别高级设置 (VAD参数)',
    speechThreshold: '语音阈值',
    silenceThreshold: '静音阈值',
    energyThreshold: '能量阈值',
    silenceDuration: '静音时长',
    voiceSynthesisSettings: '语音合成设置',
    selectVoice: '请选择音色',
    rolePrompt: '角色提示词(Prompt)',
    agentPrompt: '智能体模式下使用智能体自带的提示词，无需额外设置',
    agentPromptDesc: '智能体已包含预设的提示词和知识库，将自动使用智能体的描述作为角色提示词',
    useTemplate: '使用模板',
    custom: '自定义',
    selectTemplate: '选择模板',
    templateManagement: '模板管理',
    enterRolePrompt: '请输入角色提示词，描述角色的特点、知识背景和行为方式等',
    cancel: '取消',
    confirmDeleteRole: '确定要删除这个角色吗?',
    deleteRole: '删除角色',
    settingDefaultRole: '正在设置默认角色...',
    setAsDefaultSuccess: '已设置为默认角色',
    setAsDefaultFailed: '设置失败',
    deleteRoleSuccess: '删除成功',
    deleteRoleFailed: '删除失败',
    createRoleSuccess: '创建成功',
    updateRoleSuccess: '更新成功',
    checkForm: '请检查表单填写是否正确',
    voiceNotFound: '未找到音色信息',
    audioUrlInvalid: '音频URL无效',
    audioPlayFailed: '音频播放失败',
    getTestAudioFailed: '获取测试音频失败',
    playVoiceFailed: '播放音色失败',
    loadTemplateFailed: '加载模板列表失败',
    voskLocalRecognition: 'Vosk本地识别',
    unknown: '未知',
    unknownModel: '未知模型',
    voiceTestMessage: '您好，我是您的语音助手，很高兴为您服务',
  },

  template: {
    templateName: '模板名称',
    templateList: '提示词模板列表',
    createTemplate: '创建模板',
    editTemplate: '编辑提示词模板',
    templatePreview: '模板预览',
    category: '分类',
    templateCategory: '模板分类',
    customCategory: '自定义分类',
    templateDesc: '模板描述',
    templateContent: '模板内容',
    defaultTemplate: '默认模板',
    confirmDelete: '确定要删除此模板吗？',
    enterTemplateName: '请输入模板名称',
    selectCategory: '请选择模板分类',
    enterCustomCategory: '请输入自定义分类名称',
    enterTemplateDesc: '请输入模板描述',
    enterTemplateContent: '请输入模板内容',
    templateContentPlaceholder: '请输入模板内容，描述角色的特点、知识背景和行为方式等',
    defaultTip: '设为默认后将优先显示此模板',
    categoryBasic: '基础角色',
    categoryProfessional: '专业角色',
    categorySocial: '社交角色',
    categoryEntertainment: '娱乐角色',
    createSuccess: '模板创建成功',
    updateSuccess: '模板更新成功',
    deleteSuccess: '模板已删除',
    deleteFailed: '删除失败',
    setDefaultSuccess: '已设为默认模板',
  },

  config: {
    llm: '模型',
    stt: '语音识别',
    tts: '语音合成',
    category: '类别',
    modelType: '模型类型',
    list: '列表',
    create: '创建',
    confirmDelete: '确定要删除这个{type}配置吗?',
    pleaseEnter: '请输入',
    selectCategory: '请选择{type}类别',
    selectModelType: '请选择模型类型',
    enterName: '请输入{type}名称',
    enterDescription: '请输入{type}描述',
    enterField: '请输入{field}',
    selectCategoryFirst: '请先选择{type}类别',
    update: '更新{type}',
    parameterConfig: '参数配置',
    defaultTip: '设为默认后将优先使用此配置',
    chatModel: '对话模型',
    visionModel: '视觉模型',
    intentModel: '意图模型',
    embeddingModel: '向量模型',
    defaultChat: '默认对话',
    defaultVision: '默认视觉',
    defaultIntent: '默认意图',
    defaultEmbedding: '默认向量',
    defaultStt: '默认语音识别',
    createSuccess: '创建成功',
    updateSuccess: '更新成功',
    fillRequiredFields: '请填写必填项',
    modelNameNoChinese: '模型名称不能包含中文，请输入正确的模型名称',
    modelNameInvalid: '模型名称 "{name}" 不在有效列表中',
  },

  message: {
    content: '内容',
    type: '类型',
    sender: '发送者',
    receiver: '接收者',
    user: '用户',
    assistant: '助手',
    system: '系统',
    // 消息页面专用
    messageSender: '消息发送方',
    messageContent: '消息内容',
    voice: '语音',
    conversationTime: '对话时间',
    conversationDate: '对话日期',
    queryTable: '查询表格',
    noAudio: '无音频',
    confirmDeleteMessage: '确定要删除此消息吗？',
    today: '今天',
    thisMonth: '本月',
    prompt: {
      exportSuccess: '导出成功',
      exportFailed: '导出失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      updateSuccess: '更新成功',
      updateFailed: '更新失败',
      addSuccess: '添加成功',
      addFailed: '添加失败',
      loading: '正在加载...',
      exporting: '正在导出数据...',
      deleting: '正在删除...',
      saving: '正在保存...',
      updating: '正在更新...',
      adding: '正在添加...',
      serverMaintenance: '服务器维护/重启中，请稍后再试',
    },
  },

    agent: {
      agentName: '智能体名称',
      agentDesc: '智能体描述',
      publishTime: '发布时间',
      botId: '智能体ID',
      coze: 'Coze',
      dify: 'Dify',
      appId: 'App ID',
      spaceId: 'Space ID',
      publicKey: '公钥',
      privateKey: '私钥',
      apiUrl: 'API URL',
      apiKey: 'API Key',
      enterAppId: '请输入Coze App ID',
      enterSpaceId: '请输入Coze Space ID',
      enterPublicKey: '请输入公钥',
      enterPrivateKey: '请输入私钥',
      enterApiUrl: '请输入API URL',
      enterApiKey: '请输入API Key',
      enterAgentName: '请输入智能体名称',
    },

    account: {
      profile: '个人资料',
      phone: '手机',
      email: '电子邮件',
      password: '密码',
      confirmPassword: '确认密码',
      enterName: '请输入姓名',
      enterPhone: '请输入手机号码',
      enterEmail: '请输入邮箱地址',
      passwordPlaceholder: '留空则不修改密码',
      confirmPasswordPlaceholder: '请再次输入密码',
      passwordStrength: '强度',
      passwordLevel: {
        low: '低',
        medium: '中',
        strong: '强',
      },
      passwordTip: '请至少输入 6 个字符。请不要使用容易被猜到的密码。',
      updateSuccess: '个人信息更新成功',
      updateFailed: '更新失败',
      validation: {
        passwordStrength: '密码强度不够',
        passwordMismatch: '两次密码不一致',
      },
    },

  validation: {
    required: '此字段为必填项',
    email: '请输入有效的邮箱地址',
    phone: '请输入有效的手机号',
    password: '密码需为8-64位，且不能全为空白字符',
    confirmPassword: '两次输入的密码不一致',
    username: '用户名需为3-32位字母、数字或下划线',
    minLength: '最少{min}个字符',
    maxLength: '最多{max}个字符',
    // 通用验证消息
    enterEmail: '请输入邮箱',
    enterValidEmail: '邮箱格式不正确',
    enterLoginIdentifier: '请输入用户名、手机号或邮箱',
    enterUsername: '请输入用户名',
    usernameLength: '用户名需为3-32位字母、数字或下划线',
    enterPassword: '请输入密码',
    passwordLength: '密码需为8-64位，且不能全为空白字符',
    enterConfirmPassword: '请确认密码',
    enterVerificationCode: '请输入验证码',
    verificationCodeLength: '验证码需为6位数字',
    enterValidPhone: '手机号格式不正确',
    enterName: '请输入姓名',
    nameLength: '姓名长度需为2-20位',
    enterWebSocketUrl: '请输入 WebSocket 地址',
    enterValidWebSocketUrl: '请输入有效的地址（以 ws:// 或 wss:// 开头）',
    enterDeviceId: '请输入设备 ID',
  },

  dashboard: {
    dailySentence: '每日一句',
    clickToTranslate: '点击翻译',
    getSentenceFailed: '获取每日一句失败，使用默认值',
    conversationCount: '对话次数',
    activeDevices: '活跃设备数',
    totalDevices: '总设备数',
    todayStats: '今日统计',
    userStats: '用户统计',
    deviceStats: '设备统计',
    messageStats: '消息统计',
    systemStatus: '系统状态',
    online: '在线',
    offline: '离线',
    normal: '正常',
    abnormal: '异常',
    loading: '加载中',
    noData: '暂无数据',
    getFailed: '获取失败',

    totalRevenue: '当前共创收益',
    modelCost: '模型调用花费',
    greeting: {
      morning: '早上好',
      forenoon: '上午好',
      noon: '中午好',
      afternoon: '下午好',
      evening: '晚上好',
      night: '夜深了',
    },
    welcome: {
      rest: '休息一会儿吧',
      eat: '准备吃什么呢',
      game: '要不要打一把游戏',
      tired: '我猜你可能累了',
    },
  },

  error: {
    networkError: '网络错误，请检查网络连接',
    serverError: '服务器错误',
    unauthorized: '未授权，请重新登录',
    forbidden: '无权限访问',
    notFound: '请求的资源不存在',
    timeout: '请求超时',
    unknown: '未知错误',
  },

  table: {
    index: '序号',
    action: '操作',
    total: '共 {total} 条',
    noData: '暂无数据',
  },

  page: {
    title: {
      dashboard: '仪表盘',
      user: '用户管理',
      device: '设备管理',
      deviceMaintenance: '设备维护',
      deviceCapabilityMaintenance: '设备能力维护',
      deviceModelMaintenance: '设备型号维护',
      deviceList: '设备列表',
      deviceDetail: '设备详情',
      message: '对话管理',
      role: '角色配置',
      template: '模板管理',
      agent: '智能体管理',
      sttConfig: '语音识别配置',
      ttsConfig: '语音合成配置',
      login: '登录',
      register: '注册',
      forget: '忘记密码',
      error403: '403 - 无权限',
      error404: '404 - 页面不存在',
    },
  },

  // FaaS 工具管理
  faas: {
    toolList: '工具列表',
    toolName: '工具名称',
    toolType: '工具类型',
    category: '分类',
    publishedVersion: '已发布版本',
    draftVersion: '草稿版本',
    createTool: '新建工具',
    editTool: '编辑工具',
    deleteTool: '删除工具',
    testTool: '测试工具',
    publishVersion: '发布版本',
    rollbackVersion: '回滚版本',
    offlineVersion: '下线版本',
    execute: '执行',
    executeAsync: '异步执行',
    executionResult: '执行结果',
    inputParams: '输入参数',
    outputResult: '输出结果',
    flatResult: '打平结果',
    scriptContent: '脚本内容',
    inputFlatSchema: '输入打平配置',
    outputFlatSchema: '输出打平配置',
    versionManagement: '版本管理',
    paramConfig: '参数配置',
  },

  // 知识库管理
  knowledge: {
    baseList: '知识库列表',
    baseName: '知识库名称',
    baseType: '类型',
    documentCount: '文档数量',
    createBase: '新建知识库',
    editBase: '编辑知识库',
    deleteBase: '删除知识库',
    uploadDocument: '上传文档',
    documentList: '文档列表',
    fileName: '文件名',
    fileSize: '文件大小',
    documentStatus: '文档状态',
    indexedAt: '索引时间',
    search: '向量检索',
    searchQuery: '搜索查询',
    searchResults: '搜索结果',
    similarity: '相似度',
    reindex: '重新索引',
    generalKnowledge: '通用知识',
    professionalKnowledge: '专业知识',
    businessKnowledge: '业务知识',
    topK: '返回数量',
    threshold: '相似度阈值',
  },

  router: {
    title: {
      login: '登录',
      register: '注册',
      forget: '忘记密码',
      dashboard: '仪表盘',
      user: '用户管理',
      device: '设备管理',
      deviceMaintenance: '设备维护',
      deviceCapabilityMaintenance: '设备能力维护',
      deviceModelMaintenance: '设备型号维护',
      message: '对话管理',
      role: '角色配置',
      template: 'Prompt模板管理',
      llmConfig: 'LLM配置',
      agent: '智能体管理',
      sttConfig: '语音识别配置',
      ttsConfig: '语音合成配置',
      personalCenter: '个人中心',
      account: '个人中心',
      personalConfig: '个人设置',
      stellarAgentPrompt: 'Stellar Agent 指令',
      error403: '没有权限',
      error404: '页面不存在',
      knowledgeManagement: '知识管理',
      knowledgeBase: '知识库管理',
      knowledgePoints: '知识点列表',
      logicGraph: '知识图谱',
      logicGraphDesign: '图谱设计',
      documentLibrary: '文档库',
      fileLibrary: '文件库',
      graphImport: '图谱导入',
      knowledgeBaseDetail: '知识库详情',
      firmwareManagement: '固件管理',
      agentTemplateList: '角色管理',
      agentTemplateCreate: '创建角色',
      agentTemplateEdit: '编辑角色',
      multimodalAgentList: '角色管理',
      multimodalAgentCreate: '创建角色',
      multimodalAgentEdit: '编辑角色',
      multimodalAgent: '角色管理',
      multimodalAgentDetail: '角色详情',
      processingStrategy: '处理策略',
      perceptionData: '感知数据',
      robotList: '机器人管理',
      // New Titles
      monitorDashboard: '监控大屏',
      monitorLogs: '日志分析',
      securityDashboard: '安全态势',
      sensitiveWords: '敏感词库',
      magicAbilityMarket: '魔法工具市场',
      solutionMarket: '流程市场',
      dataMarket: '数据市场',
      deviceMarketInternal: '设备市场',

      magicToolMarket: '魔法工具市场',
      toolLibrary: '工具库',
      mcpToolManagement: 'MCP工具管理',
      orchestrator: '流程编排',
      workflowManagement: '流程管理',
      workflowTriggers: '定时触发器',
      creativeWorkshop: '创意工坊',
      testChat: '对话测试',
      robotDetail: '机器人详情',
      robotConsole: '机器人控制台',
      voiceprintManagement: '声纹识别管理',
      credentialCenter: '凭证配置中心',
      httpToolConfig: '新建HTTP工具',
      httpToolConfigEdit: '编辑HTTP工具',
      sqlToolConfig: '新建SQL工具',
      sqlToolConfigEdit: '编辑SQL工具',
      groovyToolConfig: '新建Groovy脚本',
      groovyToolConfigEdit: '编辑Groovy脚本',
      mqttToolConfig: '新建MQTT工具',
      mqttToolConfigEdit: '编辑MQTT工具',
      mcpToolConfig: '新建MCP工具',
      mcpToolConfigEdit: '编辑MCP工具',
      unifiedToolConfig: '创建工具',
      unifiedToolConfigEdit: '编辑工具',
      toolDebugger: '工具调试',
      knowledgeExtraction: '知识抽取',
      deviceDetail: '设备详情',
      // 泡芙产品管理
      chatrooms: '聊天室管理',
      chatroomDetail: '聊天室详情',
      paofuGameScripts: '娱乐中心',
      paofuExpression: '表情资源管理',
      paofuAvatars: '虚拟形象',
      paofuGameScriptDetail: '剧本详情',
      paofuConfig: '泡芙配置',
      paofuEmotion: '情绪管理',
      paofuAnalyticsDashboard: '数据分析',
      paofuAnalyticsEvents: '事件分析',
      paofuAnalyticsBehavior: '行为分析',
      paofuActivities: '活动管理',
      paofuActivityRankings: '活动排行榜',
      paofuContent: '故事管理',
      paofuGrowth: '成长任务',
      paofuMallAssets: '商城资产',
      paofuOrders: '订单管理',
      paofuProducts: '商品管理',
      paofuSocialFriends: '社交管理',
      paofuSocialInvites: '邀请管理',
      paofuSocialShares: '分享管理',
      paofuFeedback: '反馈管理',
      paofuUserProfiles: '用户画像',
      // 会员套餐管理
      memberPlanManage: '会员套餐',
      memberSubscriptionList: '会员订阅',
      intentTest: '意图识别调试',
      // 权限管理
      permissionManagement: '权限管理',
      // Robot Agent配置
      robotAgentConfig: 'Robot Agent配置',
      // 图谱可视化
      logicGraphView: '图谱可视化',
      // Agent统一管理
      unifiedAgentManagement: 'Agent统一管理',
      // 智能体配置
      agentConfig: '智能体配置',
      // 魔法工具
      magicTools: '魔法工具',
      // 音色管理
      voiceProfileList: '音色管理',
      voiceProfileCreate: '创建音色',
      voiceProfileEdit: '编辑音色',
      // 租户管理
      tenantManagement: '租户管理',
      // 菜单和角色管理
      menuManagement: '菜单管理',
      roleManagement: '角色管理',
      // 插件市场
      pluginMarketplace: '插件市场',
      pluginDetail: '插件详情',
      pluginInstalled: '已安装插件',
      pluginConnections: '外部平台',
      // 审计日志
      auditLogs: '审计日志',
      // 财务中心
      financeDashboard: '财务看板',
      accountCenterAdmin: 'Account Center 后台',
      accountCenterOverview: '概览',
      accountCenterUsers: '用户管理',
      accountCenterWallet: '钱包流水',
      accountCenterDistribution: '分销管理',
      accountCenterVerification: '认证验证码',
      // 营销中心 - 渠道管理
      channelManage: '渠道管理',
      channelAnalytics: '渠道分析',
      // 任务管理
      taskManage: '任务管理',
      // 养成管理
      growthManage: '养成管理',
      // 内容管理
      contentManage: '内容管理',
      // 内容中心（区别于泡芙内容管理）
      contentCenterManage: '内容中心',
      contentArticle: '文章管理',
      // 用户管理
      userManage: '用户管理',
      // 会员管理
      memberManage: '会员管理',
      // 分群管理
      segmentManage: '用户分群',
      // 数据分析
      dataAnalytics: '数据分析看板',
      dataExport: '数据导出',
      dataImport: '数据导入',
      dataChangeLog: '变更日志',
      apiAudit: '接口审计',
      // 商城中心
      mallProducts: '商品管理',
      mallOrders: '订单管理',
      mallCoupons: '优惠券管理',
      mallPayments: '支付交易管理',
      // 客服中心
      serviceDashboard: '客服概览',
      ticketManage: '工单管理',
      faqManage: 'FAQ管理',
      supportManualManage: '使用手册',
    },
    parent: {
      roleManagement: '音色市场',
      voiceMarket: '音色市场',
      configManagement: '配置管理',
      settings: '设置',
      orchestration: '流程编排',
      toolManagement: '工具管理',
      knowledgeManagement: '知识管理',
      deviceManagement: '智能套件',
      monitorOps: '监控运维',
      systemSecurity: '系统安全',
      dataManagement: '数据中心',
      // New Parents
      robotManagement: '智能服务',

      magicToolMarket: '魔法工具市场',
      creativeWorkshop: '创意工坊',
      systemSettings: '系统设置',
      modelManagement: '模型管理',
      solutionManagement: '智能方案',
      workflowManagement: '流程管理',
      magicAbilityMarket: '魔法工具市场',
      solutionMarket: '流程市场',
      dataMarket: '数据市场',
      deviceMarketInternal: '设备市场',
      dashboard: '仪表盘',
      system: '系统管理',
      content: '内容管理',
      monitor: '监控运维',
      security: '安全中心',
      market: '应用市场',
      creative: '创意工坊',
      // 泡芙产品管理
      paofuManagement: '泡芙产品',
      // 插件市场
      pluginMarket: '插件市场',
      // 商城中心
      mallCenter: '商城中心',
      // 财务中心
      financeCenter: '财务中心',
      // 统一账号中心
      accountCenter: '统一账号中心',
      // 营销中心
      marketingCenter: '营销中心',
      // 任务中心、养成中心、内容中心已取消虚拟父节点，直接挂泡芙产品
      // 会员中心
      memberCenter: '会员中心',
      // 数据中心
      dataCenter: '数据中心',
      // 客服中心
      serviceCenter: '客服中心',
    },

  },

  // 租户管理
  tenant: {
    title: '租户管理',
    tenantCode: '租户编码',
    tenantName: '租户名称',
    enabled: '启用',
    disabled: '禁用',
    addTenant: '新增租户',
    editTenant: '编辑租户',
    tenantCodeRequired: '请输入租户编码',
    tenantNameRequired: '请输入租户名称',
    tenantCodeLength: '租户编码长度为2-50个字符',
    tenantNameLength: '租户名称长度为2-100个字符',
    tenantCodePlaceholder: '请输入租户编码',
    tenantNamePlaceholder: '请输入租户名称',
    createSuccess: '创建租户成功',
    createFailed: '创建租户失败',
    updateSuccess: '更新租户成功',
    updateFailed: '更新租户失败',
    deleteSuccess: '删除租户成功',
    deleteFailed: '删除租户失败',
    confirmDelete: '确定要删除此租户吗？',
    confirmDeleteContent: '删除租户「{name}」后将无法恢复，是否继续？',
    confirmToggleState: '确定要{action}租户「{name}」吗？',
  },

  // 音色管理
  voice: {
    title: '音色管理',
    create: '新建音色',
    cloneAction: '克隆音色',
    editVoice: '编辑音色',
    preview: '预览',
    provider: '提供商',
    voiceId: '音色标识',
    voiceType: '类型',
    preset: '预设',
    cloned: '克隆',
    gender: '性别',
    tags: '标签',
    cloneStatus: '克隆状态',
    uploadSample: '上传音频样本',
    toolEnabled: '启用LLM音色切换',
    toolHint: '启用后，AI可根据对话内容自主选择音色',
    availableVoices: '可用音色',
    selectVoices: '选择音色',
    setDefault: '设为默认',
    minVoicesHint: '至少选择2个音色才能启用音色切换',
    male: '男性',
    female: '女性',
    neutral: '中性',
    language: '语言',
    status: '状态',
    system: '系统预置',
    apiKey: 'API Key',
    apiUrl: 'API URL',
    // 克隆状态相关
    clone: {
      pending: '等待中',
      processing: '克隆中',
      ready: '已就绪',
      failed: '克隆失败',
      submitted: '克隆任务已提交，正在处理中...',
      success: '音色克隆完成',
      error: '音色克隆失败',
      notReady: '克隆未完成，暂不可预览',
      providerHint: {
        volcengine: '需配置 accessToken/appId，克隆时间约 1-5 分钟',
        aliyun: '需配置 DashScope API Key，克隆时间约 1-3 分钟',
        elevenlabs: '需配置 API Key（elevenlabs.io），即时完成',
        fishSpeech: '需配置 API Key（fish.audio），即时完成',
        cosyvoice: '需配置本地 CosyVoice 服务地址，零样本克隆即时完成'
      }
    }
  },

  // 泡芙游戏模块
  paofuGame: {
    // 游戏类型
    gameType: {
      roleplay: '角色扮演剧本',
      galgame: '视觉小说',
      werewolf: '狼人杀',
      puzzle: '解谜游戏',
    },
    // 剧本状态
    scriptStatus: {
      draft: '草稿',
      published: '已发布',
      offline: '已下线',
    },
    // 审核状态
    auditStatus: {
      pending: '待审核',
      approved: '已通过',
      rejected: '已拒绝',
    },
    // 进度状态
    progressStatus: {
      inProgress: '进行中',
      completed: '已完成',
      abandoned: '已放弃',
    },
    // 房间状态
    roomStatus: {
      waiting: '等待中',
      playing: '游戏中',
      finished: '已结束',
      closed: '已关闭',
    },
    // 管理界面
    admin: {
      scriptList: '剧本列表',
      createScript: '创建剧本',
      editScript: '编辑剧本',
      scriptTitle: '剧本标题',
      scriptDescription: '剧本描述',
      coverImage: '封面图片',
      difficulty: '难度',
      estimatedTime: '预计时长',
      tags: '标签',
      publish: '发布',
      offline: '下线',
      audit: '审核',
      approve: '通过',
      reject: '拒绝',
      auditReason: '审核原因',
      parseDocument: '解析文档',
      uploadDocument: '上传文档',
      parseResult: '解析结果',
      extractCharacters: '提取角色',
      generateDetails: '生成详情',
      modifyByText: '文字修改',
      modifyByVoice: '语音修改',
      characterList: '角色列表',
      characterName: '角色名称',
      characterDescription: '角色描述',
      characterPersonality: '性格特点',
      characterBackground: '背景故事',
      isAiNpc: 'AI NPC',
      aiSystemPrompt: 'AI提示词',
      roleType: '角色类型',
      protagonist: '主角',
      supporting: '配角',
      npc: 'NPC',
      antagonist: '反派',
      sceneList: '场景列表',
      dialogueNodes: '对话节点',
      endings: '结局',
      confirmPublish: '确定要发布此剧本吗？',
      confirmOffline: '确定要下线此剧本吗？',
      confirmDelete: '确定要删除此剧本吗？',
      publishSuccess: '发布成功',
      offlineSuccess: '下线成功',
      auditSuccess: '审核完成',
      parseSuccess: '解析成功',
      extractSuccess: '提取成功',
      modifySuccess: '修改成功',
    },
    // 文档解析步骤
    parseSteps: {
      step1: '上传文档',
      step2: '解析预览',
      step3: '编辑角色',
      step4: '确认创建',
      selectGameType: '选择游戏类型',
      uploadTip: '支持 TXT、DOC、DOCX、PDF 格式',
      parsing: '正在解析文档...',
      extracting: '正在提取角色...',
      generating: '正在生成详情...',
      modifying: '正在修改角色...',
      recording: '录音中...',
      startRecording: '开始录音',
      stopRecording: '停止录音',
      voiceInputTip: '点击录音按钮，用语音描述您想要的修改',
      textInputTip: '请输入您想要修改的内容',
      confirmCreate: '确认创建剧本',
    },
    // 游戏大厅
    lobby: {
      availableRooms: '可用房间',
      createRoom: '创建房间',
      joinRoom: '加入房间',
      roomName: '房间名称',
      maxPlayers: '最大人数',
      currentPlayers: '当前人数',
      host: '房主',
      ready: '准备',
      unready: '取消准备',
      start: '开始游戏',
      leave: '离开房间',
      selectCharacter: '选择角色',
    },
    // 游戏进度
    progress: {
      myProgress: '我的进度',
      completionRate: '完成度',
      playTime: '游戏时长',
      currentNode: '当前节点',
      continueGame: '继续游戏',
      abandonGame: '放弃游戏',
      confirmAbandon: '确定要放弃此游戏吗？进度将无法恢复。',
    },
  },

  // 固件管理
  firmware: {
    list: '固件管理',
    upload: '上传固件',
    version: '固件版本',
    deviceType: '设备类型',
    deviceModel: '设备型号',
    activate: '激活',
    triggerOta: '触发升级',
    activeStatus: '激活状态',
    active: '已激活',
    inactive: '未激活',
    fileName: '文件名',
    fileSize: '文件大小',
    uploadTime: '上传时间',
    description: '版本描述',
    releaseNotes: '更新日志',
    confirmActivate: '确定要激活此固件版本吗？',
    confirmDelete: '确定要删除此固件版本吗？',
    selectDevice: '选择设备',
    otaSuccess: 'OTA 升级指令已发送',
  },

  // 多模态智能体
  multimodal: {
    agent: '多模态智能体',
    strategy: '处理策略',
    perception: '感知数据',
    modalityType: '模态类型',
    processingMode: '处理模式',
    priority: '优先级',
    status: '运行状态',
    start: '启动',
    stop: '停止',
    reset: '重置',
    running: '运行中',
    stopped: '已停止',
    error: '异常',
    agentName: '智能体名称',
    agentType: '智能体类型',
    robotId: '关联机器人',
    strategyName: '策略名称',
    enabled: '已启用',
    disabled: '已禁用',
    processorConfig: '处理器配置',
    confirmDelete: '确定要删除吗？',
    confirmStart: '确定要启动此智能体吗？',
    confirmStop: '确定要停止此智能体吗？',
    // Prompt模板相关
    promptTemplate: 'Prompt模板',
    selectPromptTemplate: '请选择Prompt模板',
    loadTemplatesFailed: '加载模板列表失败',
    templatePreview: '模板预览',
    templateName: '模板名称',
    templateType: '模板类型',
    version: '版本',
    description: '描述',
    systemPrompt: '系统提示词',
    userPromptTemplate: '用户提示词模板',
    variables: '变量',
    fewShotExamples: 'Few-shot示例',
    examples: '个示例',
    // 类型匹配相关
    incompatible: '不兼容',
    filteringByAgentType: '正在根据智能体类型过滤：{type}',
    compatibleOnly: '仅显示兼容',
    showAll: '显示全部',
    compatibleTemplateTypes: '兼容的模板类型',
    currentTemplateIncompatible: '当前选中的模板与智能体类型不兼容，已自动清除',
    promptTemplateTip: '选择一个适合此智能体类型的Prompt模板',
    // 其他字段
    agentNameRequired: '请输入智能体名称',
    agentNameLength: '智能体名称长度为2-50个字符',
    agentTypeRequired: '请选择智能体类型',
    inputModalitiesRequired: '请至少选择一种输入模态',
    outputModalitiesRequired: '请至少选择一种输出模态',
    loadLlmConfigsFailed: '加载LLM配置列表失败',
    selectRobot: '请选择机器人',
    robotTip: '可选：关联到特定机器人',
    enterAgentName: '请输入智能体名称',
    selectAgentType: '请选择智能体类型',
    visionUnderstanding: '视觉理解',
    audioInteraction: '语音交互',
    environmentMonitoring: '环境监测',
    taskPlanning: '任务规划',
    deviceControl: '设备控制',
    knowledgeRetrieval: '知识检索',
    enterDescription: '请输入智能体描述',
    capabilities: '能力配置',
    selectCapabilities: '请选择能力',
    capabilitiesTip: '选择智能体具备的核心能力',
    inputModalities: '输入模态',
    text: '文本',
    image: '图像',
    audio: '音频',
    video: '视频',
    outputModalities: '输出模态',
    modelConfig: '模型配置',
    llmConfig: 'LLM配置',
    selectLlmConfig: '请选择LLM配置',
    toolsBinding: '工具绑定',
    tools: '工具列表',
    availableTools: '可选工具',
    selectedTools: '已选工具',
    association: '关联配置',
    naturalLanguageUnderstanding: '自然语言理解',
    contextAwareness: '上下文感知',
    multiRoundDialogue: '多轮对话',
    objectDetection: '物体检测',
    sceneRecognition: '场景识别',
    faceRecognition: '人脸识别',
    speechRecognition: '语音识别',
    voiceSynthesis: '语音合成',
    emotionRecognition: '情感识别',
    deviceStatusQuery: '设备状态查询',
    sceneAutomation: '场景自动化',
    taskDecomposition: '任务分解',
    resourceScheduling: '资源调度',
    executionMonitoring: '执行监控',
    webSearch: '联网搜索',
    webSearchDesc: '搜索互联网信息',
    calculator: '计算器',
    calculatorDesc: '进行数学计算',
    weatherQuery: '天气查询',
    weatherQueryDesc: '查询实时天气',
    knowledgeBase: '知识库',
    knowledgeBaseDesc: '检索本地知识库',
    deviceControlTool: '设备控制',
    deviceControlToolDesc: '控制智能设备',
    loadRobotsFailed: '加载机器人列表失败',
  },

  system: {
    tip: {
      wsConnectionFailed: 'WebSocket连接失败，部分功能可能不可用',
      notConnected: '未连接到服务器，请检查聊天配置',
      connectionFailed: '连接失败: {error}',
      sendFailed: '发送失败，请检查连接状态',
      recordingFailed: '无法启动录音，请检查麦克风权限',
      stopRecordingFailed: '停止录音失败',
    }
  },

  // 凭证配置中心
  credential: {
    center: {
      title: '凭证配置中心',
      createCredential: '新建凭证',
      editCredential: '编辑凭证',
      rotateCredential: '轮换凭证',
      allServices: '全部服务',
      llm: 'LLM',
      tts: 'TTS',
      asr: 'ASR',
      vision: 'Vision',
      embedding: 'Embedding',
      entityType: '实体类型',
      entityId: '实体ID',
      entity: '实体',
      serviceType: '服务类型',
      provider: '提供商',
      credentialName: '凭证名称',
      status: '状态',
      enabled: '已启用',
      disabled: '已禁用',
      deleted: '已删除',
      createTime: '创建时间',
      searchPlaceholder: '搜索凭证名称',
      selectEntityType: '请选择实体类型',
      selectEntity: '请选择实体',
      selectServiceType: '请选择服务类型',
      selectProvider: '请选择服务提供商',
      credentialNamePlaceholder: '便于识别的名称，如：OpenAI-生产环境',
      entityTypeRequired: '请选择实体类型',
      entityIdRequired: '请选择实体',
      serviceTypeRequired: '请选择服务类型',
      providerRequired: '请选择服务提供商',
      loadFailed: '加载凭证列表失败',
      loadEntitiesFailed: '加载实体列表失败',
      createSuccess: '凭证创建成功',
      createFailed: '凭证创建失败',
      updateSuccess: '凭证更新成功',
      updateFailed: '凭证更新失败',
      deleteSuccess: '凭证删除成功',
      deleteFailed: '凭证删除失败',
      confirmDelete: '确定要删除此凭证吗？',
      enableSuccess: '凭证已启用',
      disableSuccess: '凭证已禁用',
      toggleStateFailed: '状态切换失败',
      totalItems: '共 {total} 条',
      rotate: '轮换',
      testConnection: '测试连接',
      rotateSuccess: '凭证轮换成功',
      rotateFailed: '凭证轮换失败',
      testing: '正在测试连接...',
      testSuccess: '连接测试成功',
      testFailed: '连接测试失败',
    },
  },

  // 个人设置
  settings: {
    title: '个人设置',
    preferences: '偏好设置',
    notifications: '通知管理',
    security: '安全设置',
    accountManagement: '账户管理',
    tenantManagement: '租户管理',
    theme: '界面主题',
    themeLight: '浅色',
    themeDark: '深色',
    themeSystem: '跟随系统',
    language: '界面语言',
    navigationMode: '导航模式',
    navTabs: '标签页',
    navSidebar: '侧边栏',
    defaultHome: '默认首页',
    soundEnabled: '消息提示音',
    systemNotification: '系统通知',
    systemNotificationDesc: '接收系统公告和维护通知',
    deviceAlert: '设备告警',
    deviceAlertDesc: '设备离线、异常状态告警推送',
    chatMessage: '对话消息',
    chatMessageDesc: '新对话和机器人消息通知',
    emailNotification: '邮件通知',
    emailNotificationDesc: '重要事件通过邮件推送',
    quietHours: '免打扰时段',
    quietHoursDesc: '在此时段内不发送通知',
    securityScore: '安全评分',
    securityScoreDesc: '根据账户安全配置综合评定',
    oauthBindings: '第三方账号绑定',
    wechat: '微信',
    bound: '已绑定',
    notBound: '未绑定',
    bindNow: '去绑定',
    unbind: '解绑',
    unbindConfirm: '确定要解绑此第三方账号吗？',
    unbindSuccess: '解绑成功',
    unbindFailed: '解绑失败',
    accountInfo: '账户信息',
    registerTime: '注册时间',
    dangerZone: '危险操作',
    deleteAccount: '注销账户',
    deleteAccountDesc: '注销后账户数据将被永久删除，此操作不可恢复',
    deleteAccountConfirm: '确定要注销账户吗？此操作不可恢复！',
    deleteAccountSuccess: '账户已注销',
    deleteAccountFailed: '注销账户失败',
    featureInDevelopment: '功能开发中',
    saveSuccess: '设置保存成功',
    saveFailed: '设置保存失败',
  },

  component: {
    errorBoundary: {
      title: '页面出错了',
      description: '抱歉，页面加载时发生了错误，请尝试重试或返回首页',
      retry: '重试',
      goHome: '返回首页',
    },
    settings: {
      theme: {
        dark: '深色模式',
        light: '浅色模式',
        auto: '跟随系统',
      },
    },
  },

  // 机器人控制台
  robotConsole: {
    title: '机器人控制台',
    deviceList: '设备列表',
    selectDevice: '请选择设备',
    searchDevice: '搜索设备',
    deviceInfo: '设备信息',
    deviceName: '设备名称',
    deviceId: '设备ID',
    deviceStatus: '设备状态',
    online: '在线',
    offline: '离线',
    connectionStatus: '连接状态',
    connected: '已连接',
    disconnected: '未连接',
    connecting: '连接中',

    // 标签页
    tabs: {
      chat: '对话',
      control: '控制',
      call: '通话',
      monitor: '监控',
    },

    // 对话功能
    chat: {
      inputPlaceholder: '输入消息内容...',
      send: '发送',
      sending: '发送中...',
      sendFailed: '发送失败',
      noMessages: '暂无消息',
      ctrlEnterToSend: 'Ctrl + Enter 发送',
    },

    // 控制功能
    control: {
      properties: '属性',
      methods: '方法',
      noProperties: '暂无属性',
      noMethods: '暂无方法',
      readOnly: '只读',
      writable: '可写',
      execute: '执行',
      executing: '执行中...',
      updateProperty: '更新属性',
      updating: '更新中...',
      executeSuccess: '执行成功',
      executeFailed: '执行失败',
      updateSuccess: '更新成功',
      updateFailed: '更新失败',
      parameterConfig: '参数配置',
      noParameters: '无参数',
    },

    // 状态筛选
    filter: {
      all: '全部',
      online: '在线',
      offline: '离线',
    },

    // 提示信息
    tip: {
      connectingToDevice: '正在连接到设备...',
      connectSuccess: '已连接到设备: {name}',
      connectFailed: '连接失败',
      disconnectSuccess: '已断开连接',
      selectDeviceFirst: '请先选择设备',
      deviceNotConnected: '设备未连接',
      loadingDeviceInfo: '正在加载设备信息...',
      loadDeviceInfoSuccess: '设备能力信息已加载',
      loadDeviceInfoFailed: '加载设备信息失败',
      noDeviceDescriptor: '暂无设备能力信息',
    },

    // 通话功能(占位)
    call: {
      title: '语音通话',
      comingSoon: '通话功能即将上线',
    },

    // 监控功能(占位)
    monitor: {
      title: '设备监控',
      comingSoon: '监控功能即将上线',
    },
  },
}
